module.exports = __webpack_public_path__ + "img/auditsale.1090f578.png";